import {
  compose,
  applyMiddleware,
  combineReducers,
  createStore,
} from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';

import { reducer as localeReducer } from './features/Locale';
import { reducer as authReducer } from './features/Auth';
import { reducer as notifyReducer } from './features/Notify';
import { reducer as gameReducer } from './features/Game';
import { reducer as historyReducer } from './features/History';
import { reducer as settingsReducer } from './features/Settings';
import { reducer as chatReducer } from './features/Chat';
import { reducer as jackpotReducer } from './features/Jackpot';
import { reducer as megaWinsReducer } from './features/MegaWins';
import { reducer as promoReducer } from './features/PromoList';
import { reducer as socketErrorReducer } from './features/SocketErrorBoundary';
import { reducer as newYearReducer, persistentReducer as newYearSettingsReducer } from './features/NewYear';

function configureStore(extra) {
  const middlewares = [
    thunk.withExtraArgument({ ...extra, socket: extra.socket }),
  ];

  const reducer = createReducer();

  const store = createStore(
    reducer,
    compose(
      applyMiddleware(...middlewares),
      persistState(['settings', 'newYearSettings']),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true }) : (arg => arg),
    ),
  );

  extra.socket.addSocketHandlers(store.dispatch)
  extra.chatSocket.addSocketHandlers(store.dispatch)

  return store;
}

function createReducer() {
  return combineReducers({
    locale: localeReducer,
    auth: authReducer,
    notify: notifyReducer,
    game: gameReducer,
    chat: chatReducer,
    history: historyReducer,
    settings: settingsReducer,
    jackpot: jackpotReducer,
    megaWins: megaWinsReducer,
    promo: promoReducer, 
    socketError: socketErrorReducer,
    newYear: newYearReducer,
    newYearSettings: newYearSettingsReducer,
  });
}


export { createReducer };
export default configureStore;
